export default [
    {
        path: '/forms',
        name: 'FormsIndex',
        meta: {
            requiresAuth: true,
            title: 'Forms',
        },
        components: {
            default: () => import('@views/form/FormIndex.vue'),
        },
    },
    {
        path: '/forms/create',
        name: 'FormsCreate',
        meta: {
            requiresAuth: true,
            title: 'Create form',
        },
        props: {
            default: () => ({
                isCreate: true,
            }),
        },
        components: {
            default: () => import('@views/form/FormForm.vue'),
        },
    },
    {
        path: '/forms/:id/edit',
        name: 'FormsEdit',
        meta: {
            requiresAuth: true,
            title: 'Edit form',
        },
        props: {
            default: (route) => ({
                isCreate: false,
                id: route.params.id,
            }),
        },
        components: {
            default: () => import('@views/form/FormForm.vue'),
        },
    },
    {
        path: '/forms/:id/fill',
        name: 'FormsFill',
        meta: {
            requiresAuth: true,
            title: 'Fill form',
        },
        props: {
            default: (route) => ({
                id: route.params.id,
            }),
        },
        components: {
            default: () => import('@views/form/FormFill.vue'),
        },
    },
    {
        path: '/forms/:id/submissions',
        name: 'FormsSubmissionsIndex',
        meta: {
            requiresAuth: true,
            title: 'Form submissions',
        },
        components: {
            default: () => import('@views/form/FormSubmissionIndex.vue'),
        },
    },
    {
        path: '/forms/:form_id/submissions/:submission_id/view',
        name: 'FormsSubmissionsView',
        meta: {
            requiresAuth: true,
            title: 'Form submission',
        },
        props: {
            default: (route) => ({
                form_id: route.params.form_id,
                submission_id: route.params.submission_id,
            }),
        },
        components: {
            default: () => import('@views/form/FormSubmissionView.vue'),
        },
    },
];
